import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahsanesthesia',
  templateUrl: './asahsanesthesia.component.html',
  styleUrls: ['./asahsanesthesia.component.scss']
})
export class AsahsanesthesiaComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
